"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_adapters_1 = require("@synisys/skynet-store-adapters");
var skynet_store_authentication_impl_1 = require("@synisys/skynet-store-authentication-impl");
var login_guard_service_1 = require("../../services/login-guard.service");
var core_1 = require("@angular/core");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var shell_routing_1 = require("./shell.routing");
var shared_module_1 = require("../shared.module");
var shell_container_component_1 = require("./shell.container.component");
var session_data_provider_impl_1 = require("../../provider/session-data.provider.impl");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var router_1 = require("@angular/router");
var expired_token_popup_component_1 = require("../login/expired-token-popup/expired-token-popup.component");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var toggle_full_screen_service_1 = require("./api/toggle-full-screen.service");
var toggle_full_screen_service_impl_1 = require("../../services/toggle-full-screen.service.impl");
var two_factor_authentication_module_1 = require("../login/two-factor-authentication/two-factor-authentication.module");
var basic_shared_module_1 = require("../basic-shared.module");
var countdown_module_1 = require("../countdown/countdown.module");
var session_prolong_service_1 = require("../../services/session-prolong.service");
var routing_audit_service_1 = require("../../services/routing-audit.service");
var notification_toast_container_component_1 = require("../notification-toast/notification-toast-container.component");
var ɵ0 = idm_session_data_provider_api_js_1.EventBaseImpl.getInstance(), ɵ1 = new skynet_store_authentication_impl_1.RequestPatternModel('GET', /(\/language|\/message)|\/pages\/shared\//), ɵ2 = new skynet_store_authentication_impl_1.RequestPatternModel('HEAD', /\/categories\/icons\//);
exports.ɵ0 = ɵ0;
exports.ɵ1 = ɵ1;
exports.ɵ2 = ɵ2;
var ShellContainerModule = /** @class */ (function () {
    function ShellContainerModule() {
    }
    ShellContainerModule.getRouter = function () {
        return shell_routing_1.shellRoutes;
    };
    ShellContainerModule = __decorate([
        core_1.NgModule({
            imports: [
                countdown_module_1.CountdownModule,
                basic_shared_module_1.BasicSharedModule,
                shared_module_1.SharedModule,
                router_1.RouterModule,
                idm_ng_controls_1.ControlsModule,
                two_factor_authentication_module_1.TwoFactorAuthenticationModule,
                skynet_store_adapters_1.SkynetStoreAdapterModule
            ],
            declarations: [shell_container_component_1.ShellContainerComponent, expired_token_popup_component_1.ExpiredTokenPopupComponent, notification_toast_container_component_1.NotificationToastContainerComponent],
            exports: [shell_container_component_1.ShellContainerComponent, expired_token_popup_component_1.ExpiredTokenPopupComponent, notification_toast_container_component_1.NotificationToastContainerComponent],
            providers: [
                login_guard_service_1.LoginGuard,
                idm_authorization_client_js_1.PermissionGuard,
                session_prolong_service_1.SessionProlongService,
                { provide: idm_session_data_provider_api_js_1.SessionDataProvider, useExisting: session_data_provider_impl_1.SessionDataProviderImpl },
                { provide: idm_session_data_provider_api_js_1.EventBase, useValue: ɵ0 },
                { provide: toggle_full_screen_service_1.ToggleFullScreenService, useClass: toggle_full_screen_service_impl_1.ToggleFullScreenServiceImpl },
                {
                    provide: skynet_store_authentication_impl_1.IGNORE_AUTH_TOKEN,
                    useValue: ɵ1,
                    multi: true
                },
                {
                    provide: skynet_store_authentication_impl_1.IGNORE_AUTH_TOKEN,
                    useValue: ɵ2,
                    multi: true
                },
                routing_audit_service_1.RoutingAuditService
            ]
        })
    ], ShellContainerModule);
    return ShellContainerModule;
}());
exports.ShellContainerModule = ShellContainerModule;
//# sourceMappingURL=shell.container.module.js.map